

















































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IHotelInfo } from "@/@types/hotel-info/info";
import { preferred_language } from "@/config/languags.config.json";
import { hotelInfo } from "@/config/host.config";

import FullHotelInfoList from "@/components/tables/hotel-info/full-hotel-info-list.vue";
import ButtonHistory from "@/components/buttons/button-history.vue";
import InputSearch from "@/components/app/search/input-search.vue";
import ButtonCart from "@/components/buttons/button-cart.vue";

import HotelInfoDemo from "@/components/demo/hotel-info/hotel-info-demo.vue";
import LanguagesButtons from "@/components/buttons/languages-buttons.vue";
import MainDemo from "@/components/demo/main-demo.vue";
import draggable from "vuedraggable";
import SortModal from "@/components/app/sort-modal.vue";

@Component({
  components: {
    FullHotelInfoList,
    InputSearch,
    ButtonHistory,
    ButtonCart,
    MainDemo,
    draggable,
    HotelInfoDemo,
    SortModal,
    LanguagesButtons,
  },
})
export default class HotelInfoList extends Vue {
  @Prop({ type: Array, default: () => [] }) infoList!: Array<IHotelInfo>;
  locale = preferred_language;
  search = "";

  enabled = true;
  dragging = false;
  idDemo = "";

  get demo(): IHotelInfo | null {
    const demo = this.infoList.find((el) => el._id == this.idDemo);
    return demo ? demo : null;
  }

  get infos(): Array<IHotelInfo> {
    return this.infoList.filter((item: IHotelInfo) => {
      return (
        this.$getLocale(item.name)
          .toLowerCase()
          .indexOf(this.search.toLowerCase()) > -1
      );
    });
  }

  onSaveSorts(list: Array<IHotelInfo>): void {
    this.$bvModal.hide("sortCategory");
    for (let i = 0; i < list.length; i++) {
      try {
        const url = hotelInfo.mainAPI + "/" + list[i]._id;
        this.$axios.put(url, { sort_order: i + 1 });
      } catch (e) {
        console.error(e);
      }
    }
  }

  quickChangeShow(id: string | undefined): void {
    if (!id) return;
    const info = this.infoList.find((el) => el._id == id);
    if (!info) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
      return;
    }
    this.$emit("updateInfo", { show: !info.show }, id);
  }

  mounted(): void {
    setTimeout(() => {
      console.log(this.infoList);
    }, 5000);
  }
}
